import { styled } from '@mui/system';
import { Box, Button, Card, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { colors, fontFamilies } from '../../../constants/theme';

export const LoadingSpinner = styled(CircularProgress)({
  color: '#29405A',
});

export const LoadingText = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 18,
  color: colors.primary,
});

export const ErrorBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '50vh',
  padding: 32,
});

export const ErrorTitle = styled(Typography)({
  marginBottom: 16,
  color: '#4c2e1f',
});

export const ErrorDescription = styled(Typography)({
  marginBottom: 24,
  color: '#666',
});

export const NotFoundBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '50vh',
  padding: 32,
});

export const NotFoundTitle = styled(Typography)({
  marginBottom: 16,
  color: '#4c2e1f',
});

export const LoadingContainer = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: 16,
});

export const ErrorContainer = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 32,
});

export const NotFoundContainer = styled(Box)({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 32,
});

export const PrimaryButton = styled(Button)({
  backgroundColor: '#29405A',
  color: '#FFF',
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  fontWeight: 600,
  padding: '12px 30px',
  textTransform: 'none',
  borderRadius: 4,
  '&:hover': { backgroundColor: '#1f3147' },
});

export const PageWrapper = styled(Box)({
});

export const HeroSectionWrapper = styled(Box)(({ theme }) => ({
  color: colors.primary,
  padding: '40px 20px 60px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    padding: '30px 20px 40px',
  },
}));

export const SectionContainer = styled(Box)(({ theme }) => ({
  padding: '40px 40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: '30px 20px',
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
  padding: '0 24px',
  [theme.breakpoints.down('md')]: {
    padding: '0 16px',
  },
}));

export const InfoCard = styled(Card)({
  backgroundColor: '#fff',
  borderRadius: 16,
  padding: 32,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s, box-shadow 0.2s',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
  },
});

export const SectionTitle = styled(Typography)({
  fontFamily: fontFamilies.gotham,
  fontSize: 20,
  fontWeight: 600,
  color: colors.primary,
  marginBottom: 16,
});
